import React from 'react';
import { AppBar, Toolbar, Typography, Box, Container } from '@mui/material';
import { darken } from '@mui/material/styles';
import { useOrg } from '../../context/OrgContext';

const Header = () => {
  const { name: companyName, logoUrl, colors, isPlatform } = useOrg();
  // The Apply button stands out against the bar: White Knight blue, or the company's secondary color
  const applyColor = isPlatform ? '#1976d2' : (colors.secondary || colors.primary);
  const applyHover = isPlatform ? '#1565c0' : darken(applyColor, 0.15);
  // Function to scroll to application form
  const scrollToApplicationForm = () => {
    const applicationFormSection = document.getElementById('application-form-section');
    if (applicationFormSection) {
      applicationFormSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <AppBar position="static" sx={{ backgroundColor: isPlatform ? '#87CEEB' : colors.primary, color: '#fff', boxShadow: 1 }}>
      <Container maxWidth="lg">
        <Toolbar sx={{ py: 1 }}>
          {/* Logo */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mr: 2
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: isPlatform ? '#1976d2' : colors.primary,
                borderRadius: 1,
                p: 1,
                width: 60,
                height: 60
              }}
            >
              <Box
                component="img"
                src={logoUrl || '/images/logo.png'}
                alt={`${companyName} Logo`}
                sx={{
                  width: 50,
                  height: 55,
                  objectFit: 'contain'
                }}
              />
            </Box>
          </Box>
          
          <Box sx={{ flexGrow: 1 }} />
          
          {/* Navigation Links - Optional */}
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Typography
              variant="body1"
              component="a"
              href="#"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              sx={{
                mx: 2,
                color: '#fff',
                textDecoration: 'none',
                fontWeight: 'medium',
                cursor: 'pointer',
                '&:hover': {
                  color: '#e0e0e0',
                  textDecoration: 'none'
                }
              }}
            >
              Home
            </Typography>
            <Typography
              variant="body1"
              component="a"
              href="#"
              onClick={() => {
                const aboutSection = document.querySelector('[id^="about-section"]');
                if (aboutSection) {
                  aboutSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              sx={{
                mx: 2,
                color: '#fff',
                textDecoration: 'none',
                fontWeight: 'medium',
                cursor: 'pointer',
                '&:hover': {
                  color: '#e0e0e0',
                  textDecoration: 'none'
                }
              }}
            >
              About
            </Typography>
            <Typography
              variant="body1"
              component="a"
              href="#"
              onClick={() => {
                const servicesSection = document.querySelector('[id^="services-section"]');
                if (servicesSection) {
                  servicesSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              sx={{
                mx: 2,
                color: '#fff',
                textDecoration: 'none',
                fontWeight: 'medium',
                cursor: 'pointer',
                '&:hover': {
                  color: '#e0e0e0',
                  textDecoration: 'none'
                }
              }}
            >
              Services
            </Typography>
            <Typography
              variant="body1"
              component="a"
              href="#"
              onClick={scrollToApplicationForm}
              sx={{
                mx: 2,
                color: '#fff',
                backgroundColor: applyColor,
                px: 2,
                py: 1,
                borderRadius: 1,
                textDecoration: 'none',
                fontWeight: 'bold',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'none',
                  backgroundColor: applyHover
                }
              }}
            >
              Apply
            </Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
